export default __webpack_public_path__ + "static/278201268_1748302582167945_3773849255869030189_n-a94f353e78e88e4cdc5eec2c105a2291.jpeg";